import React from "react"

export const singleCircle = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 180V48C12 44.7 14.7 42 18 42H174C177.3 42 180 44.7 180 48V174C180 177.3 177.3 180 174 180H36V168H168V54H24V180H12Z"
        fill="#fff"
      />
      <path
        d="M66 111C56.1 111 48 102.9 48 93C48 83.1 56.1 75 66 75C75.9 75 84 83.1 84 93C84 102.9 75.9 111 66 111ZM66 87C62.7 87 60 89.7 60 93C60 96.3 62.7 99 66 99C69.3 99 72 96.3 72 93C72 89.7 69.3 87 66 87Z"
        fill="#fff"
      />
      <path
        d="M48 147C48 137.1 56.1 129 66 129C75.9 129 84 137.1 84 147H96C96 130.44 82.56 117 66 117C49.44 117 36 130.44 36 147H48Z"
        fill="#fff"
      />
      <path d="M156 108H108V120H156V108Z" fill="#fff" />
      <path d="M156 81H108V93H156V81Z" fill="#fff" />
      <path d="M156 135H108V147H156V135Z" fill="#fff" />
      <path d="M180 12H12V24H180V12Z" fill="#fff" />
    </svg>
  )
}

export const doubleCircle = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 193 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M93.1797 106.5L14.6997 64.74C10.9797 62.76 10.9797 57.42 14.6997 55.44L93.1797 13.5C94.9197 12.54 97.0797 12.54 98.8197 13.5L177.3 55.32C181.02 57.3 181.02 62.64 177.3 64.62L98.8197 106.5C97.0797 107.46 94.9197 107.46 93.1797 106.5ZM30.6597 60L95.9997 95.16L161.34 60L95.9997 24.84L30.6597 60Z"
        fill="#fff"
      />
      <path
        d="M163.5 84L151.2 90.54L161.34 96L95.9996 131.16L30.6596 96L40.6796 90.6L28.4396 84.12L14.6396 91.5C10.9196 93.48 10.9196 98.82 14.6396 100.8L93.1796 142.56C94.9196 143.52 97.0796 143.52 98.8196 142.56L177.3 100.68C181.02 98.7 181.02 93.36 177.3 91.38L163.5 84Z"
        fill="#fff"
      />
      <path
        d="M163.5 120L151.2 126.54L161.34 132L95.9996 167.16L30.6596 132L40.6796 126.6L28.4396 120.12L14.6396 127.5C10.9196 129.48 10.9196 134.82 14.6396 136.8L93.1796 178.56C94.9196 179.52 97.0796 179.52 98.8196 178.56L177.3 136.68C181.02 134.7 181.02 129.36 177.3 127.38L163.5 120Z"
        fill="#fff"
      />
    </svg>
  )
}

export const tripleCircle = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M174.84 70.38L155.16 54H102V12H90V24H36.84L17.16 40.38C14.28 42.78 14.28 47.22 17.16 49.62L36.84 66H78V54H41.16L30.36 45L41.16 36H90V84H36.84L17.16 100.38C14.28 102.78 14.28 107.22 17.16 109.62L36.84 126H78V114H41.16L30.36 105L41.16 96H90V168H66V180H126V168H102V66H150.84L161.64 75L150.84 84H114V96H155.16L174.84 79.62C177.72 77.22 177.72 72.78 174.84 70.38Z"
        fill="#fff"
      />
    </svg>
  )
}

export const blackboard = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 193 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M131.94 84V180C131.94 183.3 134.64 186 137.94 186H161.94C165.24 186 167.94 183.3 167.94 180V108H155.94V174H143.94V84H131.94Z"
        fill="#fff"
      />
      <path
        d="M102 114H24V126H108C111.3 126 114 123.3 114 120V84H102V114Z"
        fill="#fff"
      />
      <path
        d="M125.94 30C125.94 43.26 136.68 54 149.94 54C163.2 54 173.94 43.26 173.94 30C173.94 16.74 163.2 6 149.94 6C136.68 6 125.94 16.74 125.94 30ZM162.3 30C162.3 36.6 156.9 42 150.3 42C143.7 42 138.3 36.6 138.3 30C138.3 23.4 143.7 18 150.3 18C156.9 18 162.3 23.4 162.3 30Z"
        fill="#fff"
      />
      <path
        d="M114 60V36C114 32.7 111.3 30 108 30H6C2.7 30 0 32.7 0 36V126H12V42H102V60H63V72H150C166.56 72 180 85.44 180 102V126H192V102C192 78.78 173.22 60 150 60H114Z"
        fill="#fff"
      />
    </svg>
  )
}

export const bookSearch = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 192 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M184.26 166.56L169.02 151.32C172.14 146.58 174 140.88 174 134.82C174 118.26 160.56 104.82 144 104.82C127.44 104.82 114 118.26 114 134.82C114 151.38 127.44 164.82 144 164.82C150.12 164.82 155.76 162.96 160.5 159.84L175.74 175.08L184.2 166.62L184.26 166.56ZM144 152.82C134.1 152.82 126 144.72 126 134.82C126 124.92 134.1 116.82 144 116.82C153.9 116.82 162 124.92 162 134.82C162 144.72 153.9 152.82 144 152.82Z"
        fill="#fff"
      />
      <path
        d="M6 27V146.94C6 150.24 8.7 152.94 12 152.94L102 152.76V140.76H90V33H150V92.82H162V27C162 23.7 159.3 21 156 21H12C8.7 21 6 23.7 6 27ZM78 140.82H18V33H78V140.82Z"
        fill="#fff"
      />
      <path d="M66.1201 48H30.1201V60H66.1201V48Z" fill="#fff" />
      <path d="M138.12 48H102.12V60H138.12V48Z" fill="#fff" />
      <path d="M66.1201 77.8799H30.1201V89.8799H66.1201V77.8799Z" fill="#fff" />
      <path d="M138.12 78H102.12V90H138.12V78Z" fill="#fff" />
      <path d="M66.1201 108H30.1201V120H66.1201V108Z" fill="#fff" />
    </svg>
  )
}

export const trophy = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 193 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M132 168H60V180H132V168Z" fill="#fff" />
      <path
        d="M174 36H150V18C150 14.7 147.3 12 144 12H48C44.7 12 42 14.7 42 18V36H18C14.7 36 12 38.7 12 42V60C12 78.24 25.68 93.36 43.32 95.64C48.24 117.9 66.96 135.06 90 137.64V156H102V137.64C125.04 135.06 143.76 117.96 148.68 95.64C166.32 93.3 180 78.24 180 60V42C180 38.7 177.3 36 174 36ZM42 83.16C31.68 80.46 24 71.16 24 60V48H42V83.16ZM138 84C138 107.16 119.16 126 96 126C72.84 126 54 107.16 54 84V24H138V84ZM168 60C168 71.16 160.32 80.46 150 83.16V48H168V60Z"
        fill="#fff"
      />
    </svg>
  )
}

export const announcement = () => {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 193 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M48 113.999H72L104.76 135.059C108.78 137.639 114 134.759 114 130.019V49.9794C114 45.2394 108.72 42.3594 104.76 44.9394L72 65.9994H18C14.7 65.9994 12 68.6994 12 71.9994V107.999C12 111.299 14.7 113.999 18 113.999H48ZM36 125.999V149.999H48V125.999H36ZM102 119.999L76.5 103.019C75.54 102.359 74.34 101.999 73.2 101.999H24V77.9994H73.2C74.4 77.9994 75.54 77.6394 76.5 76.9794L102 59.9994V119.999Z"
        fill="#fff"
      />
      <path
        d="M162.959 42.7197V42.4797L153.779 50.2197C173.279 73.3197 172.559 107.34 152.039 129.6L160.859 138C185.459 111.3 186.359 70.4397 162.959 42.7197Z"
        fill="#fff"
      />
      <path
        d="M129.479 65.9998C141.179 79.8598 140.699 100.32 128.399 113.64L137.219 121.8C153.659 103.98 154.259 76.7398 138.599 58.2598L129.479 65.9998Z"
        fill="#fff"
      />
    </svg>
  )
}

export default {
  singleCircle,
  doubleCircle,
  tripleCircle,
  blackboard,
  bookSearch,
  trophy,
  announcement
}
